<hubs-sub-menu></hubs-sub-menu>
<ul class="glitches">
  <li>
    <span (click)="later()" class="created center">Newer</span>
    <span class="hubid">Hub ID</span>
    <span class="payload">Information</span>
  </li>
  <li *ngFor="let glitch of glitches"
      (click)="gotoDetail(glitch)">
    <span class="created">{{glitch.created | godate}}</span>
    <span class="hubid">{{glitch.hubid}}</span>
    <span class="payload">{{glitch.payload}}</span>
  </li>
  <li>
    <span (click)="earlier()" class="created center">Older</span>
    <span class="hubid">Hub ID</span>
    <span class="payload">Information</span>
  </li>
</ul>
